// Chaves de API (issue #280): regras puras da tela Configurações > API.
// O backend (api/api_keys) é a fonte de autorização; aqui só montamos o payload
// e escondemos o que ele recusaria.

// "ads" não entra: nenhuma rota de ads aceita chave de API hoje (docs/api/guia-da-api.md §3).
export const API_KEY_MODULES = [
  { key: 'crm', label: 'CRM' },
  { key: 'financeiro', label: 'Financeiro' },
  { key: 'projetos', label: 'Projetos' },
  { key: 'atendimento', label: 'Atendimento' },
]

export const API_KEY_ACCESS = [
  { value: '', label: 'Sem acesso' },
  { value: 'read', label: 'Leitura' },
  { value: 'write', label: 'Leitura e escrita' },
]

export const API_KEY_EXPIRY = [
  { value: '30', label: '30 dias' },
  { value: '90', label: '90 dias' },
  { value: '180', label: '180 dias' },
  { value: '365', label: '365 dias (máximo)' },
]

const MANAGER_ROLES = new Set(['owner', 'admin'])

export function canManageApiKeys(memberships = []) {
  return memberships.some((m) => m.is_active !== false && MANAGER_ROLES.has(m.role))
}

// { crm: 'write', projetos: 'read', financeiro: '' } -> ['crm:write', 'projetos:read']
export function buildScopes(access = {}) {
  return API_KEY_MODULES
    .filter((mod) => access[mod.key] === 'read' || access[mod.key] === 'write')
    .map((mod) => `${mod.key}:${access[mod.key]}`)
}

export function scopeLabel(scope) {
  const [module, level] = String(scope).split(':')
  const mod = API_KEY_MODULES.find((m) => m.key === module)
  const name = mod ? mod.label : module
  return `${name} · ${level === 'write' ? 'escrita' : 'leitura'}`
}

const STATUS = {
  ativa: ['green', 'Ativa'],
  expirada: ['amber', 'Expirada'],
  revogada: ['red', 'Revogada'],
}

export function statusBadge(status) {
  return STATUS[status] || ['neutral', status || '-']
}

// Valida o formulário; devolve a mensagem de erro ou '' quando está tudo certo.
export function validateApiKeyForm({ name, access, target, clientId }) {
  if (!String(name || '').trim()) return 'Dê um nome para a chave.'
  if (buildScopes(access).length === 0) return 'Escolha acesso a pelo menos um módulo.'
  if (target === 'client' && !clientId) return 'Escolha o cliente da chave.'
  return ''
}

// Corpo do POST /api/api-keys. `target` é 'client' (um cliente) ou 'organization'.
export function buildCreatePayload({ name, access, target, clientId, organizationId, expiresInDays }) {
  const payload = {
    name: String(name).trim(),
    scopes: buildScopes(access),
    expires_in_days: Number(expiresInDays),
  }
  if (target === 'client') payload.client_id = clientId
  else payload.organization_id = organizationId
  return payload
}
